import { Injectable } from '@angular/core';
import { CardBackgroundViewModel } from '../../card-background-view-model';
import type { Observable } from 'rxjs';
import type { GlassHouseBrandGroupCardData } from '../../../../../../../models/print-cards/glass-house/glass-house-brand-group-card-data';

@Injectable()
export class GlassHouseBrandGroupIndexCardStackBackgroundViewModel extends CardBackgroundViewModel {
  public readonly cardData$: Observable<GlassHouseBrandGroupCardData>;
}
